import * as filterHeaderTypes from '../../../webcommon/header/filterheader/propTypes';

export const ImImpactSummary = 'ImImpactSummary';

export const columns = [
    {
        id: 'title',
        visible: true
    },
    {
        id: 'trades',
        visible: true
    },
    {
        id: 'imThresholdCollect',
        visible: true
    },
    {
        id: 'imThresholdPost',
        visible: true
    },
    {
        id: 'imAmt',
        visible: true
    },
    {
        id: 'imConf',
        visible: true
    },
    {
        id: 'imIncr',
        visible: true
    },
    {
        id: 'imTotal',
        visible: true
    }
];

const customSortFunction = (a, b) => {
    if (a.disabled > b.disabled) {
        return -1;
    }
    if (a.disabled < b.disabled) {
        return 1;
    }
    if (a.checked > b.checked) {
        return -1;
    }
    if (a.checked < b.checked) {
        return 1;
    }
    return 0;
};

export const filterDefinitions = [
    {
        id: 'counterparty',
        title: 'Counterparty',
        type: filterHeaderTypes.filterTypes.list,
        defaultValue: [],
        availableValues: undefined,
        availableValuesLocation: 'api:SystemInfo/counterparties',
        server: true,
        fixed: true,
        displayNumberSelected: true,
        wide: true,
        hideAllButton: true,
        customSort: customSortFunction,
        includeGroupTitle: false
    },
    {
        id: 'csa',
        title: 'CSA',
        type: filterHeaderTypes.filterTypes.list,
        defaultValue: [],
        availableValues: undefined,
        availableValuesLocation: 'api:SystemInfo/csas',
        server: true,
        fixed: true,
        displayNumberSelected: true,
        hideAllButton: true,
        customSort: customSortFunction,
        onlyShowValue: true
    }
];

export const defaultFilters = [
    {
        definition: filterDefinitions.find(d => d.id === 'counterparty'),
        value: []
    },
    {
        definition: filterDefinitions.find(d => d.id === 'csa'),
        value: []
    }
];

export const typeOrderingValues = {
    Dummy: 0,
    Monitoring: 1,
    IM: 2
};
